import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/Blog.css';
import '../../CSS/App.css';

const RezepeBlog = () => {
  return (
    <div className="blog-container">
      <Link to="/blog" className="blog-back-link">← Back to Blog</Link>

      <p className="blog-post-title">Building Rezepe</p>
      <p className="blog-meta">React · Node.js · Express · MySQL</p>

      <div className="blog-body">
        <p>
          Rezepe basically started because I realized I had recipes everywhere. Some were in my notes, some
          were bookmarks I completely forgot about, and some were just pictures of handwritten recipes.
        </p>
        <p>
          Obviously I could have downloaded one of the million recipe apps that already exist, but building my
          own sounded more fun and gave me an excuse to make a full-stack application from scratch.
        </p>

        <h2>Choosing the Stack</h2>
        <p>
          I used React for the frontend, Node.js and Express for the backend, and MySQL for the database.
        </p>
        <p>
          I already knew all of them enough that I wasn't spending the entire project learning a completely
          new framework, but there was still a lot I hadn't done before. I wanted to build actual
          authentication, connect everything through an API, and store everything in a real database instead
          of making something that only worked as a demo.
        </p>
        <p>
          The backend handles creating accounts, logging in with hashed passwords, and all of the normal CRUD
          operations for recipes. Since everyone should obviously only be able to see their own recipes, I
          also had to make sure every query was properly connected to the logged-in user.
        </p>

        <h2>Hosting It Myself</h2>
        <p>
          This is probably the part of the project I'm most proud of.
        </p>
        <p>
          Instead of putting it on a managed hosting service, I deployed the whole thing onto my home server.
          I set up Nginx as the reverse proxy, connected it to my domain, dealt with HTTPS, opened the ports I
          needed, and figured out how to keep the application running.
        </p>
        <p>
          There were definitely nights where something just stopped responding and I had absolutely no idea
          why. Then I'd spend forever trying different things until I finally figured out what broke.
        </p>
        <p>
          But honestly that's how I learned most of the infrastructure side of the project. Following a
          tutorial where everything works perfectly doesn't really force you to understand what's happening.
          When your own server breaks and nobody else is going to fix it for you, you kind of have to learn.
        </p>

        <h2>What I'd Change</h2>
        <p>
          If I started over today I'd probably use an ORM instead of writing every SQL query myself. Raw SQL
          was fine when the project was small, but once I started changing the database it got annoying having
          queries everywhere.
        </p>
        <p>
          I'd also spend more time planning the frontend. It works and does what I wanted it to do, but I
          definitely focused way more on getting everything behind it working than making it look polished.
        </p>
      </div>
    </div>
  );
};

export default RezepeBlog;
